import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiktok = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.17954 0H13.82C15.024 0 16 0.976 16 2.17954V13.82C16 15.024 15.024 16 13.8205 16H2.17954C0.976 16 0 15.024 0 13.8205V2.17954C0 0.976 0.976 0 2.17954 0Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.315 6.49187C11.0154 6.99231 11.8736 7.28654 12.8003 7.28654V5.50388C12.6247 5.50388 12.4501 5.48566 12.2785 5.44923V6.85232C11.3518 6.85232 10.4941 6.55767 9.79319 6.05765V9.69499C9.79319 11.5146 8.31717 12.9897 6.49672 12.9897C5.81763 12.9897 5.18608 12.7843 4.66162 12.4323C5.26028 13.0439 6.09497 13.4235 7.01849 13.4235C8.83895 13.4235 10.315 11.9483 10.315 10.1288V6.49187ZM10.959 4.69364C10.6012 4.30299 10.3661 3.79764 10.315 3.23901V3.00967H9.82028C9.94474 3.71943 10.3696 4.32611 10.959 4.69364ZM5.81315 11.0363C5.61317 10.7741 5.50518 10.4536 5.50561 10.1239C5.50561 9.29145 6.18073 8.61676 7.01362 8.61676C7.16872 8.61676 7.32296 8.64031 7.47097 8.68746V6.86521C7.29808 6.84165 7.12383 6.83146 6.94915 6.835V8.25324C6.80118 8.20609 6.64694 8.18254 6.49138 8.18254C5.65849 8.18254 4.98341 8.85723 4.98341 9.68966C4.98384 10.2785 5.32116 10.7883 5.81315 11.0363Z",
			fill: "#EC407A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.79338 6.05765C10.4938 6.55809 11.352 6.85232 12.2787 6.85232V5.44923C11.7614 5.33898 11.3036 5.06877 10.9592 4.69322C10.3698 4.32564 9.94535 3.71943 9.82094 3.00967H8.52182V10.1288C8.51871 10.9586 7.84492 11.6306 7.01381 11.6306C6.52404 11.6306 6.08893 11.3972 5.81339 11.0359C5.32135 10.7879 4.98403 10.2781 4.98403 9.68966C4.98403 8.85723 5.65914 8.18254 6.49204 8.18254C6.65157 8.18254 6.80539 8.20746 6.94981 8.25324V6.83542C5.16135 6.87233 3.72314 8.33277 3.72314 10.1292C3.72314 11.0261 4.08137 11.839 4.66271 12.4328C5.18717 12.7848 5.81872 12.9901 6.4978 12.9901C8.31826 12.9901 9.79427 11.515 9.79427 9.69546L9.79338 6.05765Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.2784 5.44979V5.07023C11.8117 5.07112 11.3549 4.94048 10.9589 4.69335C11.3091 5.07693 11.7704 5.34133 12.2784 5.44979ZM9.82018 3.00981C9.80819 2.9418 9.79932 2.87379 9.79309 2.80493V2.57559H7.9993V9.69513C7.99665 10.5249 7.32243 11.1969 6.49129 11.1969C6.24732 11.1969 6.01709 11.1391 5.8131 11.036C6.08864 11.3974 6.52376 11.6307 7.01353 11.6307C7.84463 11.6307 8.51842 10.9587 8.52154 10.1289V3.00981H9.82018ZM6.9491 6.83556V6.43159C6.7993 6.41111 6.64822 6.40092 6.49662 6.40092C4.67574 6.40092 3.2002 7.87603 3.2002 9.69559C3.2002 10.8365 3.78021 11.8418 4.66153 12.4329C4.08019 11.8391 3.72197 11.0262 3.72197 10.1293C3.72197 8.33291 5.16064 6.87247 6.9491 6.83556Z",
			fill: "#81D4FA"
		})
	]
});
export default SvgTiktok;
